// extracted by mini-css-extract-plugin
module.exports = {"h5FontSize":"LetsTalk-module--h5FontSize--_TIs5","color":"LetsTalk-module--color--2dg4h"};